import React from 'react';
import KeycloakProvider from './auth/KeycloakProvider';
import { AuthProvider } from './context/AuthContext';
import ChatScreen from './components/chat/ChatScreen';

function App() {
  return (
    <KeycloakProvider>
      <AuthProvider>
        <ChatScreen />
      </AuthProvider>
    </KeycloakProvider>
  );
}

export default App;
